module.exports = __webpack_public_path__ + "static/media/firesafes-w-shadow.d3d55715.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/model-serial-number/firesafes-w-shadow.png
// module id = 487
// module chunks = 0